// extracted by css-extract-rspack-plugin
export default {"NavPane":"ArtifactRegistryIndex-module__NavPane__oaxOC"};